<template>
  <v-sheet rounded class="px-6 pt-4 pb-2 mb-4">
    <v-row>
      <v-col :sm="12">
        <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1 mb-2">
          Pohlaví
        </p>
      </v-col>
      <v-col :sm="12" class="py-0">
        <v-radio-group
          :value="value"
          @change="val => $emit('input', val)"
          row
          class="mt-0 pt-0"
        >
          <v-col
            v-for="gender in genders"
            :key="gender.key"
            :sm="4"
            class="py-0 pl-0"
          >
            <v-radio :label="gender.name" :value="gender.key" />
          </v-col>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "Gender",
  props: {
    genders: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
}
</script>
